import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { Row } from 'reactstrap'

import Search from './Search'
import States from './States'

const FiltersWrapper = styled.div`
  margin-top: 20px;
  background-color: #fff;
  padding: 21px 18px 10px 18px;
`

class Filters extends Component {
  render() {
    const { ui, interaction } = this.props
    const { width } = ui.sizes.app
    const { selectedInteractionId } = interaction

    if (selectedInteractionId !== '' && width < 992) {
      return null
    }

    return (
      <FiltersWrapper>
        <States />
        <Row>
          <Search />
        </Row>
      </FiltersWrapper>
    )
  }
}

export default connect(({ ui, interaction }) => ({ ui, interaction }))(Filters)
